import { Link } from "react-router-dom";

const Footer = () => (
  <footer className="bg-[#0D1A32] px-6 pb-8 pt-20 text-white sm:px-10 lg:px-16">
    <div className="mx-auto max-w-7xl">
      <div className="grid gap-14 border-b border-white/10 pb-16 md:grid-cols-2 lg:grid-cols-[1.4fr_0.7fr_0.9fr]">
        <div>
          <img src="/images/logo/logo.png" alt="Zeebar Resort" className="h-24 w-24 object-contain" />
          <p className="mt-5 max-w-sm font-garamond text-2xl leading-snug text-white/80">Bhutanese warmth, modern comfort and memorable stays in the heart of Samtse.</p>
        </div>
        <div>
          <p className="footer-heading">Explore</p>
          <div className="mt-6 flex flex-col gap-4 font-montserrat text-sm text-white/65">
            <Link to="/facilities" className="hover:text-[#E0B973]">Facilities</Link><Link to="/rooms" className="hover:text-[#E0B973]">Rooms</Link><Link to="/contact" className="hover:text-[#E0B973]">Contact</Link><Link to="/condition" className="hover:text-[#E0B973]">Terms & Conditions</Link>
          </div>
        </div>
        <div>
          <p className="footer-heading">Find us</p>
          <div className="mt-6 space-y-3 font-montserrat text-sm leading-6 text-white/65"><p>Gawadrong (Allay Pakha)<br />Samtse, Bhutan</p><a href="mailto:zeebarresort@gmail.com" className="block hover:text-[#E0B973]">zeebarresort@gmail.com</a></div>
          <div className="mt-7 flex gap-5"><a href="https://www.instagram.com/zeebarresort?igsh=OHh1bXIwbDVuenpq" target="_blank" rel="noreferrer"><img src="/images/icons/IG.svg" alt="Instagram" className="h-6 w-6" /></a><a href="https://www.facebook.com/profile.php?id=100091537659714" target="_blank" rel="noreferrer"><img src="/images/icons/FB.svg" alt="Facebook" className="h-6 w-6" /></a></div>
        </div>
      </div>
      <div className="flex flex-col gap-3 pt-7 font-montserrat text-[10px] uppercase tracking-[0.18em] text-white/40 sm:flex-row sm:items-center sm:justify-between"><p>© {new Date().getFullYear()} Zeebar Resort</p><a href="https://www.nomindbhutan.com" target="_blank" rel="noreferrer" className="hover:text-white">Powered by Nomind</a></div>
    </div>
  </footer>
);

export default Footer;
